var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCollections = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  strokeDasharray: "1 4",
  strokeLinecap: "round",
  d: "M64 38c0 8.464-4.382 15.905-11 20.178M16 38c0 8.464 4.381 15.905 11 20.178m3-42.002A23.9 23.9 0 0 1 40 14c3.569 0 6.956.779 10 2.176"
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 9,
  y: 15,
  strokeWidth: 2,
  rx: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 18h14M10 21h6M22 21h6M9 24h7M22 24h7M9 27h5M24 27h5M10 30h3M25 30h3"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M25.25 32.75v-2.5a5 5 0 0 0-5-5h-2.5a5 5 0 0 0-5 5v2.5"
}), /*#__PURE__*/React.createElement("rect", {
  width: 7.5,
  height: 7.5,
  x: 15.25,
  y: 17.75,
  strokeWidth: 2,
  rx: 3.75
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 51,
  y: 15,
  strokeWidth: 2,
  rx: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M54 18h14M52 21h6M64 21h6M51 24h7M64 24h7M51 27h5M66 27h5M52 30h3M67 30h3"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M67.25 32.75v-2.5a5 5 0 0 0-5-5h-2.5a5 5 0 0 0-5 5v2.5"
}), /*#__PURE__*/React.createElement("rect", {
  width: 7.5,
  height: 7.5,
  x: 57.25,
  y: 17.75,
  strokeWidth: 2,
  rx: 3.75
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 30,
  y: 50,
  strokeWidth: 2,
  rx: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 53h14M31 56h6M43 56h6M30 59h7M43 59h7M30 62h5M45 62h5M31 65h3M46 65h3"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M46.25 67.75v-2.5a5 5 0 0 0-5-5h-2.5a5 5 0 0 0-5 5v2.5"
}), /*#__PURE__*/React.createElement("rect", {
  width: 7.5,
  height: 7.5,
  x: 36.25,
  y: 52.75,
  strokeWidth: 2,
  rx: 3.75
}))));
export default SvgCollections;